import { render, staticRenderFns } from "./DefaultDashboard.vue?vue&type=template&id=7bb16cc8&"
import script from "./DefaultDashboard.vue?vue&type=script&lang=js&"
export * from "./DefaultDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports